'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var React = require('react');
var context = require('../../context.js');
var DesktopMenu = require('./DesktopMenu.js');
var MobileMenu = require('./MobileMenu.js');

const Menu = ({ children }) => {
  const { isMobile } = React.useContext(context.HeaderContext);
  if (isMobile !== void 0) {
    if (isMobile) {
      return /* @__PURE__ */ jsxRuntime.jsx(MobileMenu.MobileMenu, {
        children
      });
    }
    return /* @__PURE__ */ jsxRuntime.jsx(DesktopMenu.DesktopMenu, {
      children
    });
  }
  return /* @__PURE__ */ jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(MobileMenu.MobileMenu, {
        children
      }),
      /* @__PURE__ */ jsxRuntime.jsx(DesktopMenu.DesktopMenu, {
        children
      })
    ]
  });
};
Menu.displayName = "Menu";

exports.Menu = Menu;
